import { routesTemplate } from "../routesTemplate";

import ForumScreen from "../../screens/forum/ForumScreen";

import TopicCreateScreen from "../../screens/forum/topic/TopicCreateScreen";
import TopicScreen from "../../screens/forum/topic/TopicScreen";
import TopicWritePostScreen from "../../screens/forum/topic/TopicWritePostScreen";
import TopicEditScreen from "../../screens/forum/topic/TopicEditPostScreen";

export const forumStack = [
    routesTemplate("/forum", ForumScreen),

    routesTemplate('/forum/topic/create', TopicCreateScreen),
    routesTemplate('/forum/topic', TopicScreen),
    routesTemplate('/forum/topic/answer', TopicWritePostScreen),
    routesTemplate('/forum/topic/answer/edit', TopicEditScreen),


];
